<template>
  <div class="notFoundPage">
    <div class="wrap clear">
      <img src="../assets/images/img401.png">
      <div class="content">
        <div class="title">{{ promptMessage }}</div>
        <div class="contacts" v-if="contactsShow">
          <div class="phone">
            <img src="@/assets/images/phonIcon.png">
            <span>{{ contactsData.phone }}</span>
          </div>
          <div class="email">
            <img src="@/assets/images/emilyIcon.png">
            <span>{{ contactsData.email }}</span>
          </div>
        </div>
        <!--        <p class="rjStyle" v-if="isRjFlag">-->
        <!--          <span>内部员工如需开通权限，请您联系以下接口人</span>-->
        <!--          <span class="deptName">锐捷网络-品牌推广部：刘娟娟</span>-->
        <!--          <span>电话：15364009798</span>-->
        <!--          <span>邮箱：liujuanjuan@ruijie.com.cn</span>-->
        <!--        </p>-->
        <!--        <p class="qdContactsStyle" v-if="qdContactsShow">-->
        <!--          <span>如需开通权限，请您联系以下接口人</span>-->
        <!--          <span class="deptName">锐捷网络-品牌推广部：张<span>硕</span></span>-->
        <!--          <span>电话：18611327828</span>-->
        <!--          <span>邮箱：zhangshuo@ruijie.com.cn</span>-->
        <!--        </p>-->
        <div v-if="!isRjFlag && applyBtnShow" class="btnBar">
          <el-button type="primary" @click="jumpPage">{{ applyBtnText }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qdSignContractApi } from '@/API/home';
export default {
  data () {
    return {
      applyBtnText: '申请权限',
      qdSignContractStatus: 0,
      promptMessage: '您好，您尚未开通锐捷市场活动申请权限！',
      applyBtnShow: false,
      contactsShow: false,
      stateMessageShow: false,
      contactsData: {
        phone: '',
        email: ''
      }
    };
  },
  computed: {
    isRjFlag () {
      return this.$store.state.userInfo.userType === 'rj';
    }
  },
  methods: {
    jumpPage () {
      this.$router.push('/qdSignContract');
    },
    paramsConversion (data) {
      let result = {
        secondParty: data.secondParty,
        juridicalPerson: data.lealPerson,
        contacts: data.contact,
        phone: data.contactPhone,
        email: data.contactEmail,
        address: data.address,
        bank: data.bank,
        accountName: data.bankAcountName,
        accountNumber: data.bankAcount,
        taxPayerCode: data.taxPayerCode
      };
      return result;
    },
    getSignContractStatus () {
      let { userInfo } = this.$store.state;
      qdSignContractApi.getQdSignContractInfo(userInfo.sysUser.userId).then(res => {
        if (res.status === '200') {
          if (res.data) {
            let { stat } = res.data;
            this.qdSignContractStatus = stat;
            switch (stat) {
              case 0:
                this.contactsShow = false;
                this.applyBtnShow = false;
                break;
              case 1:
                this.$router.push('/');
                break;
              case 2:
                this.promptMessage = '请继续填写提交，提交成功后，请等待渠道运营部审批，为您开通活动申请权限，\n' +
                  '\n' +
                  '                             若遇到问题，请联系对应销售询问';
                this.applyBtnText = '继续申请';
                this.applyBtnShow = true;
                this.$store.commit('setQdSignContractFormInfo', this.paramsConversion(res.data));
                break;
              case 3:
                this.promptMessage = '您已提交成功，请等待渠道运营部审批后，为您开通活动申请权限\n' +
                  '\n' +
                  '                             ，若遇到问题，请联系对应销售询问';
                break;
              case 4:
                this.promptMessage = `驳回原因：${ res.data.rejectReason }`;
                this.applyBtnText = '重新提交';
                this.applyBtnShow = true;
                this.$store.commit('setQdSignContractFormInfo', this.paramsConversion(res.data));
                break;
            }
          } else {
            this.contactsShow = false;
            this.applyBtnShow = true;
          }
        }
      });
    }
  },
  mounted () {
    if (!this.isRjFlag) {
      // this.contactsData.phone = '18611327828';
      // this.contactsData.email = 'zhangshuo@ruijie.com.cn';
      let { userInfo } = this.$store.state;
      if (userInfo.partnerTypeName && (userInfo.partnerTypeName.indexOf('商业白金') >= 0 || userInfo.partnerTypeName.indexOf('服务商') >= 0)) {
        this.getSignContractStatus();
      } else {
        this.promptMessage = '您好，您的账号类型没有申请市场活动的权限！您可以联系对应销售咨询';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notFoundPage{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #FFFFFF;
  >.wrap{
    width: 1000px;
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-64%);
    text-align: center;
    >img{
      width: 648px;
    }
    >.content{
      width: 560px;
      position: absolute;
      left: 50%;
      top: 420px;
      margin-left: -280px;
      color: #424c57;
      >.title{
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 20px;
      }
      >.contacts{
        text-align: center;
        margin-bottom: 40px;
        >div{
          font-size: 18px;
          >img{
            width: 18px;
            margin-right: 6px;
            vertical-align: middle;
          }
          >span{
            display: inline-block;
            vertical-align: middle;
          }
        }
        >.phone{
          display: inline;
          margin-right: 50px;
        }
        >.email{
          display: inline;
        }
      }
    }
  }
}
</style>
